import * as React from 'react';
import { ISimpleInputProps, SimpleInput, TChildPosition } from '../SimpleInput';

interface IInputMProps extends ISimpleInputProps {
  stackLength: number;
  index: number;
}

export class InputM extends React.Component<IInputMProps> {
  public render() {
    const { ref, stackLength, ...other } = this.props;
    const {
      insideLabel,
      index,
    } = this.props;
    const position: { [item: string]: TChildPosition } = {
      0: 'first-child',
      [stackLength - 1]: 'last-child',
    };

    return <SimpleInput
      {...other}
      insideLabel={index + 1 === stackLength ? insideLabel : undefined}
      childPosition={position[index]}
    />;
  }
}
